var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "api-layer" }, [
    _c("fieldset", [
      _c("legend", [_vm._v("RoomCall-Mixer")]),
      _c("div", { staticClass: "api-box" }, [
        _c("label", { staticClass: "api-title" }, [_vm._v("info")]),
        _c("button", { on: { click: _vm.getMixerInfo } }, [_vm._v("OK")]),
        !!_vm.callInfo.desc
          ? _c("div", [_c("pre", [_vm._v(_vm._s(_vm.callInfo.desc))])])
          : _vm._e(),
      ]),
      _c("div", { staticClass: "api-box" }, [
        _c("label", { staticClass: "api-title" }, [_vm._v("mixerId")]),
        _vm._v(" roomId:"),
        _c("input", { attrs: { type: "text", name: "roomId" } }),
        _c("button", { on: { click: _vm.getMixerId } }, [_vm._v("OK")]),
        _c("div", { staticClass: "desc-inline" }),
      ]),
      _c("div", { staticClass: "api-box" }, [
        _c("label", { staticClass: "api-title" }, [_vm._v("recreate")]),
        _vm._v(" roomId:"),
        _c("input", { attrs: { type: "text", name: "roomId" } }),
        _c("button", { on: { click: _vm.recreate } }, [_vm._v("OK")]),
      ]),
      _c("div", { staticClass: "api-box" }, [
        _c("label", { staticClass: "api-title" }, [_vm._v("reEnter roomUser")]),
        _vm._v(" roomId:"),
        _c("input", { attrs: { type: "text", name: "roomId" } }),
        _vm._v(" userId:"),
        _c("input", { attrs: { type: "text", name: "userId" } }),
        _c("button", { on: { click: _vm.reEnter } }, [_vm._v("OK")]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }